import React, { Component } from "react";

class Submit extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
  };

  constructor(props) {
    super(props);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }

    this.onClickEvent = this.onClickEvent.bind(this);
    events["onClick"] = this.onClickEvent;

    this.state = {
      action: this.props.property.action ? this.props.property.action : "",
      events: events,
    };
  }

  onClickEvent() {
    this.props.manager.templateRef.current.setState({
      action: this.state.action,
    });
  }

  componentDidMount() {
    this.setState({
      defaultValue: this.props.value,
      attributes: this.props.property.attributes,
      caption: this.props.property.caption,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  render() {
    return (
      <button type="submit" {...this.state.attributes} {...this.state.events}>
        {this.state.caption}
      </button>
    );
  }
}

export default Submit;
